import * as z from "zod";

const actionCount = z.object({
  eventType: z.string(),
  label: z.string(),
  count: z.number(),
});

export const shopperAgentActionsAnalytics = {
  name: "shopperAgentActionsAnalytics" as const,
  input: z.object({ start: z.date(), end: z.date() }),
  output: z.object({
    totalActions: z.number(),
    actions: z.array(actionCount),
    links: z.object({ clicked: z.number() }),
  }),
};
